import { IoAddOutline } from 'react-icons/io5';
import { Table } from 'components';
import {
  THead,
  Tr,
  Th,
  Td,
  TdFixed,
  ThFixed,
  TBody,
  DataStatus,
  ActionButton,
  SelectSearch,
} from 'components';
import { useContext } from 'react';
import {
  DropdownTransferBahanProduksiContext,
  TransferBahanProduksiContext,
} from '../../Context';

export const TablePermintaanBPF = ({ data = [] }) => {
  const { dropdownStatusPermintaan } = useContext(
    DropdownTransferBahanProduksiContext
  );
  const { setModalForm, setDataPermintaan } = useContext(
    TransferBahanProduksiContext
  );

  const onChangeStatusPermintaan = ({ value, index }) => {
    const copyData = [...data];
    copyData[index]['status_permintaan'] = value;

    setDataPermintaan((prv) => ({
      ...prv,
      penunjang: copyData,
    }));
  };

  return (
    <Table>
      <THead>
        <Tr className="text-center">
          <ThFixed>No.</ThFixed>
          <Th>Item Barang</Th>
          <Th>Qty. Permintaan</Th>
          <Th width={150}>Status Permintaan</Th>
          <ThFixed>Aksi</ThFixed>
        </Tr>
      </THead>

      <TBody>
        {data?.length ? (
          data.map((val, index) => (
            <Tr key={index}>
              <TdFixed className="text-center">{index + 1}</TdFixed>
              <Td>{val.nama_item}</Td>
              <TdFixed textRight>
                {parseFloat(val.qty)} {val.nama_satuan}
              </TdFixed>
              <td className="p-0 align-self-center">
                <SelectSearch
                  option={dropdownStatusPermintaan}
                  defaultValue={dropdownStatusPermintaan?.find(
                    ({ value }) => value === val.status_permintaan
                  )}
                  onChange={({ value }) =>
                    onChangeStatusPermintaan({ value, index })
                  }
                />
              </td>
              <Td>
                <div className="d-flex justify-content-center align-items-center">
                  <ActionButton
                    disable={val.tgl_transfer_produksi_bahan}
                    size="sm"
                    className="m-1"
                    onClick={() =>
                      setModalForm({
                        show: true,
                        type: 'penunjang',
                        data: val,
                      })
                    }
                  >
                    <IoAddOutline />
                  </ActionButton>
                </div>
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={5}>
              <DataStatus text="Tidak ada data" />
            </Td>
          </Tr>
        )}
      </TBody>
    </Table>
  );
};
